// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2fv_F","title":"BackImages_title__2IB2w","images":"BackImages_images__1OaBS"};